import { render, staticRenderFns } from "./allocationStorehouseEnterList.vue?vue&type=template&id=62c1d05d&scoped=true"
import script from "./allocationStorehouseEnterList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseEnterList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseEnterList.vue?vue&type=style&index=0&id=62c1d05d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c1d05d",
  null
  
)

export default component.exports